module.exports = __webpack_public_path__ + "media/images/steps/step_7-056babfa4b612900e3a8e484860af56e.svg";